import { render, staticRenderFns } from "./WorkflowNext.vue?vue&type=template&id=36c381e0&"
import script from "./WorkflowNext.vue?vue&type=script&lang=js&"
export * from "./WorkflowNext.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowNext.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports